import { Anchor, Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";
import { viewAssignmentsCss } from "./ViewAllAssignments.style";

const propTypes = {
  allAssignmentsLink: PropTypes.string,
  streamProperties: PropTypes.object,
};

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const ViewAllAssignments = ({ allAssignmentsLink, streamProperties }) => {
  const eventProperties = {
    objectType: "Assignment",
    actionPrefix: "Initiate",
    actionName: "Navigate",
    streamProperties: {
      ...streamProperties,
      description: "View all assignments list page",
    },
  };

  return (
    <AnchorWithTrackEvent
      __cssFor={viewAssignmentsCss}
      dataProps={{ "data-qa-selector": "view-assignments-link" }}
      href={allAssignmentsLink}
      openInNewTab
      styleAnchorAsButton={{
        flavor: Button.flavors.muted,
      }}
      {...eventProperties}
    >
      View all assignments
    </AnchorWithTrackEvent>
  );
};

ViewAllAssignments.propTypes = propTypes;

export default ViewAllAssignments;
